/* @flow */
import { ActionTypes } from '../constants/MessageComposerConstants';
import { dispatcher } from 'lib/Dispatcher';

const MessageComposerActions = {
  saveState(chatId: Backbone$Id | number, state: Object) {
    dispatcher.dispatch({
      type: ActionTypes.SAVE_STATE,
      chatId,
      state,
    });
  },
};

export default MessageComposerActions;
